module.exports = __webpack_public_path__ + "img/cold_sweat.444733c1.png";